var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"page"},[_c('HomeBanner'),_c('AboutBanner'),_c('ProjectBanner'),_vm._m(0)],1),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer"},[_c('p',[_vm._v("This is a work in progress, please don't mind the mess.")])])
}]

export { render, staticRenderFns }